import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    DEACTIVATE_USER: (userId) => ({ userId }),
    API: {
      DEACTIVATE_USER: apiResourceActionCreator('profile')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/deactivateUser/${payload.userId}`, authToken, {}, actions.admin.api.deactivateUser);

function* deactivateUser(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'deactivateUser',
  action: actions,
  sagas: deactivateUser,
  reducers: {
    request: (state, action) => ({
      ...state,
      isDeactivatingUser: true,
      error: null
    }),
    success: (state, action) => {
      const updated = action.payload.profile
      const existingIndividualUser = fp.find(
        (existing) => existing.user.id === updated.user.id
      )(state.userData.result)
      return ({
        ...state,
        isDeactivatingUser: false,
        userData: {
          ...state.userData,
          result: fp.flow(
            fp.map(
              (existing) => existing.user.id === updated.user.id ? updated : existing
            ),
            (result) => {
              const newIndividualUser = existingIndividualUser ? [] : [updated]
              return newIndividualUser.concat(result)
            }
          )(state.userData.result)
        },
        businessUserData: {
          ...state.businessUserData,
          result: fp.filter(
            (existing) => existing.user.id !== updated.user.id
          )(state.businessUserData.result)
        }
      })
    },
    failed: (state, action) => ({
      ...state,
      isDeactivatingUser: false,
      error: action.payload.error,
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/deactivateUser.js